module.exports = __webpack_public_path__ + "static/media/사내근로복지기금.4e2dffe1.png";